import {getCookie, getLang, setCookie} from '../../common/Utils';
import Modal from '../modal/Modal';
import {checkCookie} from './checkCookie';
import {ncBannerI18n, ncBannerOptions} from '../../interface/ICommonbanner';
import { l10nAllLang } from '../../common/L10n';

/**
 * @category Commonbanner
 * @description
 * 영상 배너
 * 메인페이지에서만 노출
 * 단, 이미지 레이어가 활성화 되어 있으면 노출 하지 않음
 * 그만보기 클릭 -> 브라우저 쿠키가 삭제 되기 전까지 팝업 안됨
 * youtube 인지 CDN 영상인지 체크 후 contents 값 다르게 호출
 */

class MovieLayer {
    isCookieApply: boolean;
    constructor(_isMain: boolean = false, _isLauncher: boolean = false, _data: ncBannerOptions) {

        this.isCookieApply = checkCookie();
        let thisIsCookieApply = this.isCookieApply && getCookie(_data.movieCookie);

        if( !_isMain || !_data.showMovieBanner || thisIsCookieApply || _data.showImageBanner){
            return;
        }

        if ( _isLauncher && !_data.movieLauncherShow) {
            return;
        }


       let contents;
        if( _data.movieCDN) {
            contents = '<video class="video" src="' + _data.movieURL + '" autoplay controls loop muted></video>';
        } else {
            if(_data.youtubeID != '') {
                contents = '<iframe width="100%" height="100%" src="https://www.youtube.com/embed/' + _data.youtubeID +'?loop=1&playlist=' + _data.youtubeID +'" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
            } else {
                contents = '<iframe width="100%" height="100%" src="' + _data.movieURL +'" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
            }

        }

	    let lang = getLang() || 'en';	
        let l10n = l10nAllLang[lang].commonBanner;
        
        let ncBannerModalMovie = new Modal({
            id: 'NC-banner-movie',
            contents: contents,
            primaryBtnText: l10n.stop_watching,
            cancelBtnText: l10n.close,
            willOpen: ()=>{},
            didClose: (_result: boolean)=>this.addEvents( _result, _data )
        });

        ncBannerModalMovie.open();

    }
    addEvents(_result: boolean, _data: ncBannerOptions){
        const movieBody = document.querySelector('#NC-banner-movie .nc-modal__body');
        if(_result) {
            if(this.isCookieApply){
                setCookie('ncBanner'+_data.movieCookie, "true", 999, '.ncsoft.com'); // 쿠키 사용 (lineage2m nct)
                setCookie('ncBanner'+_data.movieCookie, "true", 999, '.ncsoft.jp'); // 쿠키 사용 (lineage2m ncj)
                setCookie('ncBanner'+_data.movieCookie, "true", 999, '.plaync.com');
            }
        }
        if(movieBody != undefined){
            movieBody.innerHTML='';
        }       
    }

}
export default MovieLayer;